import '../../base/badge/index.js';
import '../../base/content_label/index.js';

import {html} from 'lit';
import {customElement, property, query} from 'lit/decorators.js';
import {FlywheelComponent} from '@gl/lit/lib/component.js';
import styles from './style.scss';
import type {Tag} from '@gl/lit/types/audiences.js';
import {BadgeVariants} from '@gl/lit/components/base/badge/index.js';
import type FlyDropdown from '@gl/lit/components/base/dropdown/index.js';
import {MsgTag} from '@gl/lit/components/base/dropdown/index.js';

export const AUDIENCE_TAGS_ELEMENT_TAG = 'audience-tags';

/**
 * Displays audience tags in a beautiful way.
 */
@customElement(AUDIENCE_TAGS_ELEMENT_TAG)
export default class AudienceTags extends FlywheelComponent {
  @property({type: Array})
  tags: Tag[] = [];

  @property({type: Number})
  limit = 2;

  @property({type: Boolean, attribute: false})
  showDropdown = false;

  @query('fly-dropdown')
  dropdown?: FlyDropdown;

  @property({type: String})
  tagName = 'Tags';

  static get styles() {
    return [styles];
  }

  get computedTagList(): Tag[] {
    return this.limit ? this.tags.slice(0, this.limit) : this.tags;
  }

  openDropdown() {
    if (this.dropdown) {
      this.dropdown.onAction({tag: MsgTag.OPEN});
    }
  }

  closeDropdown() {
    const event = new CustomEvent('close');
    if (this.dropdown) this.dropdown.dispatchEvent(event);
  }

  render() {
    return html`
      <div class="audience-tags">
        ${this.computedTagList.map(tag => {
          return html`
            <fly-badge variant=${BadgeVariants.PRIMARY_LIGHT}>
              ${tag.name}
            </fly-badge>
          `;
        })}
        <fly-dropdown
          ?active=${this.showDropdown}
          @closed=${() => {
            const timeout = setTimeout(() => {
              if (this.showDropdown) this.showDropdown = false;
              clearTimeout(timeout);
            }, 100);
          }}
        >
          ${this.tags.length > this.limit
            ? html`
                <button
                  id="anchor"
                  @click=${(e: MouseEvent) => {
                    e.stopPropagation();
                    this.showDropdown = !this.showDropdown;
                  }}
                  slot="anchor"
                  class="audience-tags__plus"
                  style="padding: 4px;"
                >
                  <div style="display: flex; align-items: center;">
                    <span>+</span>
                    <span style="margin-left: 3px;">
                      ${this.tags.length - this.limit}
                    </span>
                  </div>
                </button>
              `
            : ''}
          <div class="audience-tags__dropdown-content" slot="surface">
            <fly-content-label small>${this.tagName}</fly-content-label>
            ${this.tags.map(tag => {
              return html`
                <fly-badge variant=${BadgeVariants.PRIMARY_LIGHT}>
                  ${tag.name}
                </fly-badge>
              `;
            })}
          </div>
        </fly-dropdown>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'audience-tags': AudienceTags;
  }
}
